import React from 'react';
import { Box, Button, Flex, Spinner, Text } from '@chakra-ui/react';
import * as dateFns from 'date-fns';
import { enGB } from 'date-fns/locale';
import { useEffect, useState } from 'react';
import { DateRangePicker } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { FaChevronDown, FaFilePdf } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import {
  DownloadSettlementPDF,
  GetSettelementsData,
} from 'reactRedux/thunks/settlementsThunk/SettlementsThunk';
import { formatCurrency, formatDate } from 'utils/CommonFunction';
import { customStaticRanges, sideBarRoutes } from 'utils/StaticData';

const SettlementsList = () => {
  const dispatch = useDispatch();
  const { getSettlementsData, isLoading, isPDFDownload } = useSelector(
    (state) => state.SettlementsSlice,
  );
  const { adminDetails } = useSelector((state) => state.authSlice);
  const [showCalendar, setShowCalendar] = useState(false);
  const [dateRange, setDateRange] = useState([
    {
      startDate: dateFns.startOfMonth(new Date()),
      endDate: new Date(),
      key: 'selection',
    },
  ]);
  const currency = adminDetails?.region?.currency ?? 'EUR';
  const [calendarFilterTitle, setCalendarFilterTitle] =
    useState('Month to Date');
  const [tempCalendarFilterTitle, setTempCalendarFilterTitle] =
    useState('Month to Date');
  const [tempDateRange, setTempDateRange] = useState(dateRange);

  const handleClear = () => {
    setDateRange(tempDateRange);
    setShowCalendar(false);
  };

  const handleApply = async () => {
    setDateRange(tempDateRange);
    const startDate = dateFns.format(tempDateRange[0]?.startDate, 'yyyy-MM-dd');
    const endDate = dateFns.format(tempDateRange[0]?.endDate, 'yyyy-MM-dd');
    setCalendarFilterTitle(tempCalendarFilterTitle);
    setShowCalendar(false);
    dispatch(
      GetSettelementsData({
        start: startDate,
        end: endDate,
      }),
    );
  };

  const handleSelect = (ranges) => {
    const selectedRange = customStaticRanges.find(
      (range) =>
        range.range().startDate.getTime() ===
          ranges.selection.startDate.getTime() &&
        range.range().endDate.getTime() === ranges.selection.endDate.getTime(),
    );

    setTempCalendarFilterTitle(selectedRange?.label || 'Custom');
    setTempDateRange([ranges.selection]);
  };

  useEffect(() => {
    const startDate = dateFns.format(tempDateRange[0]?.startDate, 'yyyy-MM-dd');
    const endDate = dateFns.format(tempDateRange[0]?.endDate, 'yyyy-MM-dd');
    dispatch(
      GetSettelementsData({
        start: startDate,
        end: endDate,
      }),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const profitShare = () => {
    if (!getSettlementsData?.profitShare?.length) return '';

    return adminDetails?.role === sideBarRoutes?.Admin ? (
      <Box borderBottom={'1px solid #D9D9D9'} pb={2} mb={2}>
        <Flex gap={4} justifyContent={'space-between'} mb={2}>
          <Text fontWeight={'semibold'} fontSize={'xl'} cursor={'default'}>
            Profit Share
          </Text>
          {/* <Text fontWeight={'semibold'} fontSize={'xl'} cursor={'default'}>
            {formatCurrency(
              getSettlementsData?.totalSellerCommission,
              currency,
            )}
          </Text> */}
        </Flex>
        {getSettlementsData?.profitShare?.map((profit, index) => (
          <>
            <Flex
              gap={4}
              justifyContent={'space-between'}
              key={index}
              // _hover={{ backgroundColor: '#E2E8F090' }}
            >
              <Text
                fontSize={'lg'}
                fontWeight={'semibold'}
                // paddingLeft={{ base: '2', md: '36px' }}
                cursor={'default'}
              >
                {profit?.shareFor} ({profit?.profitShare}%)
              </Text>
              <Text cursor={'default'} fontSize={'lg'} fontWeight={'semibold'}>
                {formatCurrency(profit?.profitShareAmount, currency)}
              </Text>
            </Flex>
            {/* new code start */}
            <Box
              border={'2px solid #D9D9D9'}
              borderRadius="20"
              p={4}
              mt={3}
              mb={2}
            >
              <Box borderBottom={'1px solid #D9D9D9'} pb={2} mb={2}>
                <Flex gap={4} justifyContent={'space-between'}>
                  <Text
                    cursor={'default'}
                    fontWeight={'semibold'}
                    fontSize={'xl'}
                  >
                    Gross Revenue
                  </Text>
                  <Text
                    cursor={'default'}
                    fontWeight={'semibold'}
                    fontSize={'xl'}
                  >
                    {formatCurrency(profit?.grossRevenue, currency)}
                  </Text>
                </Flex>
                <Flex gap={4} justifyContent={'space-between'}>
                  <Text
                    cursor={'default'}
                    paddingLeft={{ base: '2', md: '36px' }}
                  >
                    Tax {`(${profit?.taxRate}%)`}
                  </Text>
                  <Text cursor={'default'}>
                    {' '}
                    - {formatCurrency(profit?.tax, currency)}
                  </Text>
                </Flex>
                <Flex gap={4} justifyContent={'space-between'}>
                  <Text
                    cursor={'default'}
                    paddingLeft={{ base: '2', md: '36px' }}
                  >
                    Net revenue
                  </Text>
                  <Text cursor={'default'}>
                    {formatCurrency(profit?.netRevenue, currency)}
                  </Text>
                </Flex>
              </Box>
              <Box borderBottom={'1px solid #D9D9D9'} pb={2} mb={2}>
                <Flex gap={4} justifyContent={'space-between'}>
                  <Text
                    cursor={'default'}
                    fontWeight={'semibold'}
                    fontSize={'xl'}
                  >
                    Merchants payouts
                  </Text>
                  <Text
                    cursor={'default'}
                    fontWeight={'semibold'}
                    fontSize={'xl'}
                  >
                    -{' '}
                    {formatCurrency(profit?.totalMerchantCommission, currency)}
                  </Text>
                </Flex>
                {profit?.merchantCommission?.map((merchant, index) => (
                  <>
                    <Flex
                      gap={4}
                      justifyContent={'space-between'}
                      key={index}
                      _hover={{ backgroundColor: '#E2E8F090' }}
                    >
                      <Text
                        cursor={'default'}
                        paddingLeft={{ base: '2', md: '36px' }}
                      >
                        {merchant?.merchant}
                      </Text>
                      <Box
                        flex="1"
                        borderBottom="1px dashed gray"
                        opacity={0.4}
                        marginBottom="5px"
                      />
                      <Text cursor={'default'}>
                        - {formatCurrency(merchant?.commission, currency)}
                      </Text>
                    </Flex>
                  </>
                ))}
              </Box>
              <Box borderBottom={'1px solid #D9D9D9'} pb={2} mb={2}>
                <Flex gap={4} justifyContent={'space-between'}>
                  <Text
                    fontWeight={'semibold'}
                    fontSize={'xl'}
                    cursor={'default'}
                  >
                    Sales payouts
                  </Text>
                  <Text
                    fontWeight={'semibold'}
                    fontSize={'xl'}
                    cursor={'default'}
                  >
                    - {formatCurrency(profit?.totalSellerCommission, currency)}
                  </Text>
                </Flex>
                {profit?.sellerCommission?.map((sales, index) => (
                  <>
                    <Flex
                      gap={4}
                      justifyContent={'space-between'}
                      key={index}
                      _hover={{ backgroundColor: '#E2E8F090' }}
                    >
                      <Text
                        paddingLeft={{ base: '2', md: '36px' }}
                        cursor={'default'}
                      >
                        {sales?.seller}
                      </Text>
                      <Box
                        flex="1"
                        borderBottom="1px dashed gray"
                        opacity={0.4}
                        marginBottom="5px"
                      />
                      <Text cursor={'default'}>
                        - {formatCurrency(sales?.commission, currency)}
                      </Text>
                    </Flex>
                  </>
                ))}
              </Box>
              <Box borderBottom={'1px solid #D9D9D9'} pb={2} mb={2}>
                <Flex gap={4} justifyContent={'space-between'}>
                  <Text cursor={'default'}>Lost powerbanks</Text>
                  <Text cursor={'default'}>
                    - {formatCurrency(profit?.lostPowerbnak ?? 0, currency)}
                  </Text>
                </Flex>
              </Box>
              <Box borderBottom={'1px solid #D9D9D9'} mb={2} pb={2}>
                <Flex gap={4} justifyContent={'space-between'}>
                  <Text cursor={'default'}>Transaction Cost</Text>
                  <Text cursor={'default'}>
                    - {formatCurrency(profit?.transactionCost ?? 0, currency)}
                  </Text>
                </Flex>
                <Flex gap={4} justifyContent={'space-between'}>
                  <Text cursor={'default'}>Customer Purchase</Text>
                  <Text cursor={'default'}>
                    - {formatCurrency(profit?.customerPurchases ?? 0, currency)}
                  </Text>
                </Flex>
              </Box>
              <Box pb={2} borderBottom={'1px solid #D9D9D9'} mb={2}>
                <Flex gap={4} justifyContent={'space-between'} key={index}>
                  <Text cursor={'default'}>
                    Revive Share ({profit?.profitShare}%)
                  </Text>
                  <Text cursor={'default'}>
                    -{formatCurrency(profit?.reviveShare, currency)}
                  </Text>
                </Flex>
              </Box>
              <Box pb={2}>
                <Flex gap={4} justifyContent={'space-between'}>
                  <Text
                    cursor={'default'}
                    fontWeight={'semibold'}
                    fontSize={'xl'}
                  >
                    Profit
                  </Text>
                  <Text
                    cursor={'default'}
                    fontWeight={'semibold'}
                    fontSize={'xl'}
                  >
                    {formatCurrency(profit?.total, currency)}
                  </Text>
                </Flex>
              </Box>
            </Box>
            {/* new code end */}
          </>
        ))}
      </Box>
    ) : (
      <Box borderBottom={'1px solid #D9D9D9'} pb={2} mb={2}>
        {getSettlementsData?.profitShare?.map((profit, index) => (
          <>
            <Flex gap={4} justifyContent={'space-between'} key={index}>
              <Text cursor={'default'}>
                {profit?.shareFor} ({profit?.profitShare}%)
              </Text>
              <Text cursor={'default'}>
                -{formatCurrency(profit?.profitShareAmount, currency)}
              </Text>
            </Flex>
          </>
        ))}
      </Box>
    );
  };

  const handleDownloadSettlement = () => {
    dispatch(
      DownloadSettlementPDF(
        {
          start: dateFns.format(dateRange[0]?.startDate, 'yyyy-MM-dd'),
          end: dateFns.format(dateRange[0]?.endDate, 'yyyy-MM-dd'),
        },
        () => {},
      ),
    );
  };

  return (
    <>
      <Box pt={{ base: '60px', md: '80px', xl: '80px' }} minH={'90vh'}>
        {isLoading ? (
          <>
            <Box
              position="absolute"
              top="0"
              left="0"
              right="0"
              bottom="0"
              backgroundColor="rgba(85, 85, 85, 0.1)"
              zIndex="9"
              display="flex"
              justifyContent="center"
              alignItems="center"
            >
              <Flex direction="column" align="center" justify="center">
                <Spinner size="xl" color="black" thickness="4px" />
              </Flex>
            </Box>
          </>
        ) : (
          <>
            <Box bg="white" p="5" borderRadius="20">
              <Flex
                justifyContent="space-between"
                alignItems={{ base: 'flex-start', md: 'center' }}
                mb={5}
                gap={{ base: '3', md: '5' }}
                position="relative"
                flexWrap="wrap"
                flexDirection={{ base: 'column', md: 'row' }}
              >
                {/* Left Side: Overview */}
                <Text fontSize="2xl" fontWeight="semibold" color="#203946">
                  Overview
                </Text>

                {/* Right Side: Download + Date Filter grouped together */}
                <Flex alignItems="center" gap="3" flexWrap="wrap">
                  <Button
                    py="10px"
                    px="15"
                    fontWeight="semibold"
                    type="button"
                    bg="white"
                    border="1px solid"
                    borderColor="reviveGray"
                    color="#292D32"
                    borderRadius="8px"
                    onClick={() => setShowCalendar(!showCalendar)}
                    justifyContent="space-between"
                    width={{ base: '100%', md: 'auto' }}
                  >
                    {calendarFilterTitle}{' '}
                    <FaChevronDown size={11} style={{ marginLeft: '8px' }} />
                  </Button>
                  <Button
                    py="10px"
                    px="15px"
                    fontWeight="semibold"
                    borderRadius="8px"
                    bg="primary"
                    color="white"
                    _hover={{ bg: 'primary', opacity: 0.8 }}
                    type="button"
                    leftIcon={<FaFilePdf size={25} />}
                    isLoading={isPDFDownload}
                    loadingText="Downloading..."
                    onClick={() => handleDownloadSettlement()}
                    width={{ base: '100%', md: 'auto' }}
                  >
                    Download PDF
                  </Button>
                </Flex>

                {/* Date Range Picker Dropdown */}
                {showCalendar && (
                  <>
                    <Box
                      position="fixed"
                      bg="rgb(0 0 0 / 40%)"
                      top="0"
                      left="0"
                      right="0"
                      bottom="0"
                      zIndex="9"
                      onClick={() => setShowCalendar(false)}
                    />
                    <Box
                      p="32px"
                      position="absolute"
                      top="50px"
                      right="0"
                      zIndex="10"
                      bg="white"
                      boxShadow="0px 0px 40px rgba(32, 57, 70, 0.06)"
                      borderRadius="20px"
                      className="custom-date-picker"
                    >
                      <DateRangePicker
                        ranges={tempDateRange}
                        onChange={handleSelect}
                        showSelectionPreview={true}
                        moveRangeOnFirstSelection={false}
                        months={2}
                        direction="horizontal"
                        locale={enGB}
                        minDate={new Date(2000, 0, 1)}
                        maxDate={new Date()}
                        staticRanges={customStaticRanges}
                        inputRanges={[]}
                      />
                      <Flex justifyContent="right" gap="12px" marginTop="30px">
                        <Button
                          className="clear-btn"
                          border="1px solid"
                          borderColor="reviveGray"
                          borderRadius="10px"
                          onClick={handleClear}
                        >
                          Clear
                        </Button>
                        <Button
                          className="apply-btn"
                          bg="#6658fd"
                          border="1px solid"
                          borderColor="#6658fd"
                          color="white"
                          borderRadius="10px"
                          _hover={{
                            bg: 'transparent',
                            color: '#6658fd',
                          }}
                          onClick={handleApply}
                        >
                          Apply
                        </Button>
                      </Flex>
                    </Box>
                  </>
                )}
              </Flex>

              <Box
                bg="white"
                p={5}
                borderRadius={'20'}
                height={'100%'}
                fontWeight={500}
                color={'#292D32'}
                boxShadow={'0px 0px 20px rgba(32, 57, 70, 0.08)'}
                border={'1px solid #D9D9D9'}
              >
                <Text
                  cursor={'default'}
                  fontSize="xl"
                  fontWeight="semibold"
                  mb="2"
                  color={'#203946'}
                >
                  Selected Period{' '}
                  {`${formatDate(dateRange[0].startDate)} to ${formatDate(
                    dateRange[0].endDate,
                  )}`}
                </Text>
                <Box borderBottom={'1px solid #D9D9D9'} pb={2} mb={2}>
                  <Flex gap={4} justifyContent={'space-between'}>
                    <Text
                      cursor={'default'}
                      fontWeight={'semibold'}
                      fontSize={'xl'}
                    >
                      Gross Revenue
                    </Text>
                    <Text
                      cursor={'default'}
                      fontWeight={'semibold'}
                      fontSize={'xl'}
                    >
                      {formatCurrency(
                        getSettlementsData?.grossRevenue,
                        currency,
                      )}
                    </Text>
                  </Flex>
                  <Flex gap={4} justifyContent={'space-between'}>
                    <Text
                      cursor={'default'}
                      paddingLeft={{ base: '2', md: '36px' }}
                    >
                      Tax {`(${getSettlementsData?.taxRate}%)`}
                    </Text>
                    <Text cursor={'default'}>
                      {' '}
                      - {formatCurrency(getSettlementsData?.tax, currency)}
                    </Text>
                  </Flex>
                  <Flex gap={4} justifyContent={'space-between'}>
                    <Text
                      cursor={'default'}
                      paddingLeft={{ base: '2', md: '36px' }}
                    >
                      Net revenue
                    </Text>
                    <Text cursor={'default'}>
                      {formatCurrency(getSettlementsData?.netRevenue, currency)}
                    </Text>
                  </Flex>
                </Box>
                <Box borderBottom={'1px solid #D9D9D9'} pb={2} mb={2}>
                  <Flex gap={4} justifyContent={'space-between'}>
                    <Text
                      cursor={'default'}
                      fontWeight={'semibold'}
                      fontSize={'xl'}
                    >
                      Merchants payouts
                    </Text>
                    <Text
                      cursor={'default'}
                      fontWeight={'semibold'}
                      fontSize={'xl'}
                    >
                      -{' '}
                      {formatCurrency(
                        getSettlementsData?.totalMerchantCommission,
                        currency,
                      )}
                    </Text>
                  </Flex>
                  {getSettlementsData?.merchantCommission?.map(
                    (merchant, index) => (
                      <>
                        <Flex
                          gap={4}
                          justifyContent={'space-between'}
                          key={index}
                          _hover={{ backgroundColor: '#E2E8F090' }}
                        >
                          <Text
                            cursor={'default'}
                            paddingLeft={{ base: '2', md: '36px' }}
                          >
                            {merchant?.merchant}
                          </Text>
                          <Box
                            flex="1"
                            borderBottom="1px dashed gray"
                            opacity={0.4}
                            marginBottom="5px"
                          />
                          <Text cursor={'default'}>
                            - {formatCurrency(merchant?.commission, currency)}
                          </Text>
                        </Flex>
                      </>
                    ),
                  )}
                </Box>
                <Box borderBottom={'1px solid #D9D9D9'} pb={2} mb={2}>
                  <Flex gap={4} justifyContent={'space-between'}>
                    <Text
                      fontWeight={'semibold'}
                      fontSize={'xl'}
                      cursor={'default'}
                    >
                      Sales payouts
                    </Text>
                    <Text
                      fontWeight={'semibold'}
                      fontSize={'xl'}
                      cursor={'default'}
                    >
                      -{' '}
                      {formatCurrency(
                        getSettlementsData?.totalSellerCommission,
                        currency,
                      )}
                    </Text>
                  </Flex>
                  {getSettlementsData?.sellerCommission?.map((sales, index) => (
                    <>
                      <Flex
                        gap={4}
                        justifyContent={'space-between'}
                        key={index}
                        _hover={{ backgroundColor: '#E2E8F090' }}
                      >
                        <Text
                          paddingLeft={{ base: '2', md: '36px' }}
                          cursor={'default'}
                        >
                          {sales?.seller}
                        </Text>
                        <Box
                          flex="1"
                          borderBottom="1px dashed gray"
                          opacity={0.4}
                          marginBottom="5px"
                        />
                        <Text cursor={'default'}>
                          - {formatCurrency(sales?.commission, currency)}
                        </Text>
                      </Flex>
                    </>
                  ))}
                </Box>
                <Box borderBottom={'1px solid #D9D9D9'} pb={2} mb={2}>
                  <Flex gap={4} justifyContent={'space-between'}>
                    <Text cursor={'default'}>Lost powerbanks</Text>
                    <Text cursor={'default'}>
                      -{' '}
                      {formatCurrency(
                        getSettlementsData?.lostPowerbnak ?? 0,
                        currency,
                      )}
                    </Text>
                  </Flex>
                  <Flex gap={4} justifyContent={'space-between'}>
                    <Text cursor={'default'}>Customer Purchase</Text>
                    <Text cursor={'default'}>
                      -{' '}
                      {formatCurrency(
                        getSettlementsData?.customerPurchases ?? 0,
                        currency,
                      )}
                    </Text>
                  </Flex>
                </Box>
                <Box borderBottom={'1px solid #D9D9D9'} pb={2} mb={2}>
                  <Flex gap={4} justifyContent={'space-between'}>
                    <Text cursor={'default'}>Transaction Cost</Text>
                    <Text cursor={'default'}>
                      -{' '}
                      {formatCurrency(
                        getSettlementsData?.transactionCost ?? 0,
                        currency,
                      )}
                    </Text>
                  </Flex>
                </Box>
                {profitShare()}
                <Box pb={2}>
                  <Flex gap={4} justifyContent={'space-between'}>
                    <Text
                      cursor={'default'}
                      fontWeight={'semibold'}
                      fontSize={'xl'}
                    >
                      Profit
                    </Text>
                    <Text
                      cursor={'default'}
                      fontWeight={'semibold'}
                      fontSize={'xl'}
                    >
                      {formatCurrency(getSettlementsData?.total, currency)}
                    </Text>
                  </Flex>
                </Box>
              </Box>
            </Box>
          </>
        )}
      </Box>
    </>
  );
};

export default SettlementsList;
